import { defineStore } from 'pinia';

import { fetchWrapper } from '@/helpers';
import { router } from '@/router';
import { useAlertStore } from '@/stores';
import { apolloClient } from '@/apollo-client';

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        returnUrl: null
    }),
    actions: {
        async login(username, password) {
            try {
                const user = await fetchWrapper.post(`${fetchWrapper.url}api/login`, { username, password });
                // update pinia state
                this.user = user;

                // store user details and jwt in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));

                // redirect to previous url or default to home page
                router.push(this.returnUrl || '/');
            } catch (error) {
                // fetch-wrapper.js's handleResponse() rejects with a plain
                // string (the backend's message) or an HTTP status number,
                // never an Error object -- so it's `error` itself that's the
                // message, not `error.message` (which is always undefined on
                // a string/number and was silently hiding the real reason).
                console.error('Login failed:', error);
                const alertStore = useAlertStore();
                alertStore.error(typeof error === 'string' ? error : 'Login failed. Please check your credentials and try again.');
            }
        },
        async logout() {
            this.user = null;
            localStorage.removeItem('user');
            localStorage.removeItem('platform');
            localStorage.removeItem('selected_stock');
            // Any alerts raised by in-flight queries that clearStore() below
            // is about to interrupt belong to the session that's ending --
            // don't let them bleed into the login screen that's about to show.
            useAlertStore().clear();
            await apolloClient.clearStore().catch(() => {});
            router.push('/account/login');
        }
    }
});
